export default "__VITE_ASSET__Tghf6Eha__"